import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#000] px-5">
      <div className="footer footer-center py-8 text-base-300 flex justify-center items-center">
        <p>copyright©2023-All right reserved by Jharna Khatun</p>
      </div>
    </footer>
  );
};

export default Footer;
